import type { SVGProps } from 'react';

type IconProps = SVGProps<SVGSVGElement> & { size?: number };

function I({ size = 16, strokeWidth = 1.5, ...p }: IconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      {...p}
    />
  );
}

export function IconHome(p: IconProps) {
  return (
    <I {...p}>
      <path d="M3 11 12 4l9 7" />
      <path d="M5 10v10h14V10" />
    </I>
  );
}

export function IconUsers(p: IconProps) {
  return (
    <I {...p}>
      <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
      <circle cx="9" cy="7" r="4" />
      <path d="M22 21v-2a4 4 0 0 0-3-3.87" />
      <path d="M16 3.13a4 4 0 0 1 0 7.75" />
    </I>
  );
}

export function IconSearch(p: IconProps) {
  return (
    <I {...p}>
      <circle cx="11" cy="11" r="7" />
      <path d="m21 21-4.3-4.3" />
    </I>
  );
}

export function IconPlus(p: IconProps) {
  return (
    <I strokeWidth={2} {...p}>
      <path d="M12 5v14M5 12h14" />
    </I>
  );
}

export function IconLogout(p: IconProps) {
  return (
    <I {...p}>
      <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" />
      <path d="m16 17 5-5-5-5" />
      <path d="M21 12H9" />
    </I>
  );
}

export function IconSun(p: IconProps) {
  return (
    <I {...p}>
      <circle cx="12" cy="12" r="4" />
      <path d="M12 2v2M12 20v2M4.93 4.93l1.41 1.41M17.66 17.66l1.41 1.41M2 12h2M20 12h2M4.93 19.07l1.41-1.41M17.66 6.34l1.41-1.41" />
    </I>
  );
}

export function IconMoon(p: IconProps) {
  return (
    <I {...p}>
      <path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79Z" />
    </I>
  );
}

export function IconMonitor(p: IconProps) {
  return (
    <I {...p}>
      <rect x="2" y="3" width="20" height="14" rx="2" />
      <path d="M8 21h8M12 17v4" />
    </I>
  );
}

export function IconChevronRight(p: IconProps) {
  return (
    <I {...p}>
      <path d="m9 6 6 6-6 6" />
    </I>
  );
}

export function IconArrowLeft(p: IconProps) {
  return (
    <I {...p}>
      <path d="M19 12H5" />
      <path d="m12 19-7-7 7-7" />
    </I>
  );
}

export function IconArrowRight(p: IconProps) {
  return (
    <I {...p}>
      <path d="M5 12h14" />
      <path d="m12 5 7 7-7 7" />
    </I>
  );
}

export function IconMore(p: IconProps) {
  return (
    <I {...p}>
      <circle cx="5" cy="12" r="1" />
      <circle cx="12" cy="12" r="1" />
      <circle cx="19" cy="12" r="1" />
    </I>
  );
}

export function IconDownload(p: IconProps) {
  return (
    <I {...p}>
      <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
      <path d="M7 10l5 5 5-5" />
      <path d="M12 15V3" />
    </I>
  );
}

export function IconChevronDown(p: IconProps) {
  return (
    <I {...p}>
      <path d="m6 9 6 6 6-6" />
    </I>
  );
}

export function IconPencil(p: IconProps) {
  return (
    <I {...p}>
      <path d="M12 20h9" />
      <path d="M16.5 3.5a2.121 2.121 0 0 1 3 3L7 19l-4 1 1-4 12.5-12.5Z" />
    </I>
  );
}
